// Main JS File

import '../fonts/fonts.css';
import '../css/app.css';

console.log('Bummed Theme Loaded');

import { initNewsletter } from './components/newsletter.js';

// jQuery is available via WordPress core
jQuery(document).ready(function ($) {
    console.log('jQuery is ready');

    // Pre-fetch Portals Care checkout URL template
    let portalsCheckoutUrlTemplate = 'https://bummed.portals.care/checkouts/:cartId';
    const org = window.organization || 'bummed';
    fetch('https://public-api.portals.care/v2/carts/checkout-url', {
        headers: { 'organization': org }
    })
    .then(res => res.ok ? res.text() : null)
    .then(text => {
        if (text) {
            portalsCheckoutUrlTemplate = text.trim();
            console.log('Portals checkout URL template loaded:', portalsCheckoutUrlTemplate);
        }
    })
    .catch(err => console.error('Failed to pre-fetch Portals checkout URL:', err));

    // Dynamic Loading for Card Carousels (Products and Info Cards)
    const cardCarouselElement = document.querySelector('.bummed-card-carousel');

    if (cardCarouselElement) {
        import('./components/card-carousel.js')
            .then(({ initCardCarousel }) => {
                initCardCarousel();
                console.log('Card Carousel Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Card Carousel:', err);
            });
    }

    // Dynamic Loading for Hero Slider
    const heroSliderElement = document.querySelector('.bummed-hero-slider');

    if (heroSliderElement) {
        import('./components/hero-slider.js')
            .then(({ initHeroSlider }) => {
                initHeroSlider();
                console.log('Hero Slider Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Hero Slider:', err);
            });
    }

    // Dynamic Loading for Accordion
    const accordionElement = document.querySelector('.bummed-accordion');

    if (accordionElement) {
        import('./components/accordion.js')
            .then(({ initAccordion }) => {
                initAccordion();
                console.log('Accordion Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Accordion:', err);
            });
    }

    // Dynamic Loading for Product Gallery
    const productGalleryElement = document.querySelector('.product-gallery-slider');

    if (productGalleryElement) {
        import('./components/product-gallery.js')
            .then(({ initProductGallery }) => {
                initProductGallery();
                console.log('Product Gallery Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Product Gallery:', err);
            });
    }

    // Dynamic Loading for Split Slider Content
    const splitSliderElement = document.querySelector('.bummed-split-slider');

    if (splitSliderElement) {
        import('./components/split-slider-content.js')
            .then(({ initSplitSlider }) => {
                initSplitSlider();
                console.log('Split Slider Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Split Slider:', err);
            });
    }

    // Dynamic Loading for Quote Slider
    const quoteSliderElement = document.querySelector('.bummed-quote-swiper');

    if (quoteSliderElement) {
        import('./components/quote-slider.js')
            .then(({ initQuoteSlider }) => {
                initQuoteSlider();
                console.log('Quote Slider Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Quote Slider:', err);
            });
    }

    // Dynamic Loading for Reviews Slider
    const reviewsSliderElement = document.querySelector('.bummed-reviews-swiper');

    if (reviewsSliderElement) {
        import('./components/reviews-slider.js')
            .then(({ initReviewsSlider }) => {
                initReviewsSlider();
                console.log('Reviews Slider Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Reviews Slider:', err);
            });
    }

    // Dynamic Loading for TikTok Slider
    const tiktokSliderElement = document.querySelector('.bummed-tiktok-swiper');

    if (tiktokSliderElement) {
        import('./components/tiktok-slider.js')
            .then(({ initTikTokSlider }) => {
                initTikTokSlider();
                console.log('TikTok Slider Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load TikTok Slider:', err);
            });
    }

    // Initialize Newsletter
    initNewsletter();

    // Dynamic Loading for Team Members
    const teamMembersElement = document.querySelector('.bummed-team-members');

    if (teamMembersElement) {
        import('./components/team-members.js')
            .then(({ initTeamMembers }) => {
                initTeamMembers();
                console.log('Team Members Loaded Dynamically');
            })
            .catch(err => {
                console.error('Failed to load Team Members:', err);
            });
    }

    // Elementor Preview Support (Always register these hooks)
    $(window).on('elementor/frontend/init', () => {
        // Quote Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_quote_slider.default', ($scope) => {
            const $swiper = $scope.find('.bummed-quote-swiper');
            if ($swiper.length) {
                import('./components/quote-slider.js').then(({ initQuoteSlider }) => {
                    initQuoteSlider();
                });
            }
        });

        // Product Gallery Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_product_gallery_slider.default', ($scope) => {
            const $swiper = $scope.find('.product-gallery-slider');
            if ($swiper.length) {
                import('./components/product-gallery.js').then(({ initProductGallery }) => {
                    initProductGallery();
                });
            }
        });

        // Split Slider Content
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_split_slider_content.default', ($scope) => {
            const $swiper = $scope.find('.bummed-split-slider');
            if ($swiper.length) {
                import('./components/split-slider-content.js').then(({ initSplitSlider }) => {
                    initSplitSlider();
                });
            }
        });

        // Reviews Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_reviews_slider.default', ($scope) => {
            const $swiper = $scope.find('.bummed-reviews-swiper');
            if ($swiper.length) {
                import('./components/reviews-slider.js').then(({ initReviewsSlider }) => {
                    initReviewsSlider();
                });
            }
        });

        // Newsletter
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_newsletter.default', ($scope) => {
            const $newsletter = $scope.find('.bummed-newsletter');
            if ($newsletter.length) {
                import('./components/newsletter.js').then(({ initNewsletter }) => {
                    initNewsletter();
                });
            }
        });

        // Team Members
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_team_members.default', ($scope) => {
            const $component = $scope.find('.bummed-team-members');
            if ($component.length) {
                import('./components/team-members.js').then(({ initTeamMembers }) => {
                    initTeamMembers();
                });
            }
        });

        // Info Card Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_info_card_slider.default', ($scope) => {
            const $carousel = $scope.find('.bummed-card-carousel');
            if ($carousel.length) {
                import('./components/card-carousel.js').then(({ initCardCarousel }) => {
                    initCardCarousel();
                });
            }
        });

        // TikTok Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_tiktok_slider.default', ($scope) => {
            const $slider = $scope.find('.bummed-tiktok-swiper');
            if ($slider.length) {
                import('./components/tiktok-slider.js').then(({ initTikTokSlider }) => {
                    initTikTokSlider();
                });
            }
        });

        // Hero Slider
        elementorFrontend.hooks.addAction('frontend/element_ready/bummed_hero_slider.default', ($scope) => {
            const $swiper = $scope.find('.bummed-hero-slider');
            if ($swiper.length) {
                import('./components/hero-slider.js').then(({ initHeroSlider }) => {
                    initHeroSlider();
                });
            }
        });
    });

    // Mobile Menu Toggle logic
    const $mobileMenuToggle = $('#mobile-menu-toggle');
    const $mobileMenu = $('#mobile-menu');
    const $hamburgerIcon = $('#hamburger-icon');
    const $closeIcon = $('#close-icon');
    const $mobileMenuClose = $('.mobile-menu-close');

    function toggleMobileMenu() {
        if (!$mobileMenu.length) return;
        
        const isExpanded = $mobileMenuToggle.attr('aria-expanded') === 'true';
        const newState = !isExpanded;

        $mobileMenuToggle.attr('aria-expanded', newState);
        
        if (newState) {
            $mobileMenu.removeClass('hidden');
            // Force reflow
            $mobileMenu[0].offsetHeight;
            $mobileMenu.addClass('is-open');
            $('body').addClass('overflow-hidden');
            $hamburgerIcon.addClass('hidden');
            $closeIcon.removeClass('hidden');
        } else {
            $mobileMenu.removeClass('is-open');
            $('body').removeClass('overflow-hidden');
            $hamburgerIcon.removeClass('hidden');
            $closeIcon.addClass('hidden');
            
            // Wait for transition
            setTimeout(() => {
                if (!$mobileMenu.hasClass('is-open')) {
                    $mobileMenu.addClass('hidden');
                }
            }, 300);
        }
    }

    if ($mobileMenuToggle.length && $mobileMenu.length) {
        $mobileMenuToggle.on('click', function (e) {
            e.preventDefault();
            toggleMobileMenu();
        });

        if ($mobileMenuClose.length) {
            $mobileMenuClose.on('click', function (e) {
                e.preventDefault();
                toggleMobileMenu();
            });
        }

        // Mobile Mega Menu accordion interaction
        $mobileMenu.on('click', '.menu-item > a', function(e) {
            const $link = $(this);
            const $megaMenu = $link.next('.mobile-mega-menu');
            const isProducts = $link.text().trim() === 'Products';

            if (isProducts && $megaMenu.length) {
                e.preventDefault();
                const $chevron = $link.find('svg');
                
                $megaMenu.toggleClass('hidden');
                $chevron.toggleClass('rotate-90');
                
                // Close other potential accordions if needed
                // For now, only Products has a mega menu
            }
        });
    }

    /**
     * Product Card Add to Cart
     * Handles click on product card buttons with SKU data
     */
    $(document).on('click', '.product-card-add-to-cart', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const productId = $btn.attr('data-product-sku');
        const itemName = $btn.attr('data-item-name');
        const productWpId = $btn.attr('data-product-id');
        const productPrice = parseFloat($btn.attr('data-product-price')) || 0;

        console.log('Add to cart clicked:', { productId, itemName, productPrice });

        // Push to GTM dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "shop_add_to_cart",
            event_source: "shop_page",
            item_name: itemName,
            ecommerce: {
                currency: "USD",
                value: productPrice,
                items: [{
                    item_id: productId || productWpId,
                    item_name: itemName,
                    price: productPrice,
                    quantity: 1,
                    item_sku: productId
                }]
            }
        });

        if (window.cpAddItemsToCart && productId) {
            window.cpAddItemsToCart([{ productId: productId }]);
        }
    });

    /**
     * Product Card Buy Now
     * Handles click on buy now buttons: adds to cart and redirects to checkout
     */
    $(document).on('click', '.product-card-buy-now', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const productId = $btn.attr('data-product-sku');
        const itemName = $btn.attr('data-item-name');
        const productWpId = $btn.attr('data-product-id');
        const productPrice = parseFloat($btn.attr('data-product-price')) || 0;

        if (!productId) {
            console.error('No product SKU provided');
            return;
        }

        // Open new blank tab immediately to bypass popup blocker
        const checkoutTab = window.open('about:blank', '_blank');

        // Disable button and show loader/feedback
        const originalText = $btn.html();
        $btn.addClass('pointer-events-none opacity-80').html('Processing...');

        console.log('Buy now clicked:', { productId, itemName, productPrice });

        // Push to GTM dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "shop_buy_now",
            event_source: "product_focus_widget",
            item_name: itemName,
            ecommerce: {
                currency: "USD",
                value: productPrice,
                items: [{
                    item_id: productId || productWpId,
                    item_name: itemName,
                    price: productPrice,
                    quantity: 1,
                    item_sku: productId
                }]
            }
        });

        const cartId = localStorage.getItem('cart-id');
        const apiBase = 'https://public-api.portals.care/v2/carts';
        const postUrl = cartId ? `${apiBase}/${cartId}/items` : apiBase;

        // Step 1: Add item to Portals Cart via API
        fetch(postUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'organization': org
            },
            body: JSON.stringify([{ productId: productId, quantity: 1 }])
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Cart updated via API successfully:', data);
            
            // Save new cart-id if created
            const activeCartId = data._id || data.id || cartId;
            if (activeCartId) {
                localStorage.setItem('cart-id', activeCartId);
            }

            // Sync the react cart app state silently
            if (window.cpAddItemsToCart) {
                try {
                    window.cpAddItemsToCart([{ productId: productId }], false);
                } catch (err) {
                    console.error('Failed to sync React cart app:', err);
                }
            }

            // Redirect using pre-fetched template
            let redirectUrl = portalsCheckoutUrlTemplate.replace(':cartId', activeCartId);
            const queryParams = window.location.search || '';
            if (queryParams) {
                const cleanQuery = queryParams.replace(/^\?/, '');
                redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + cleanQuery;
            }

            console.log('Redirecting to Portals checkout:', redirectUrl);
            
            if (checkoutTab) {
                checkoutTab.location.href = redirectUrl;
            } else {
                window.location.href = redirectUrl;
            }

            // Re-enable button on current page
            $btn.removeClass('pointer-events-none opacity-80').html(originalText);
        })
        .catch(error => {
            console.error('Buy Now API flow failed, falling back:', error);
            
            // Fallback: If we have a cart-id in localStorage, try redirecting to default portals checkouts URL
            const fallbackCartId = localStorage.getItem('cart-id');
            if (fallbackCartId) {
                const fallbackUrl = `https://bummed.portals.care/checkouts/${fallbackCartId}${window.location.search || ''}`;
                if (checkoutTab) {
                    checkoutTab.location.href = fallbackUrl;
                } else {
                    window.location.href = fallbackUrl;
                }
                $btn.removeClass('pointer-events-none opacity-80').html(originalText);
            } else {
                // If completely failed, close the opened tab
                if (checkoutTab) {
                    checkoutTab.close();
                }
                $btn.removeClass('pointer-events-none opacity-80').html(originalText);
                if (window.cpAddItemsToCart) {
                    window.cpAddItemsToCart([{ productId: productId }]);
                }
            }
        });
    });


    $(document).on('click', '.add-all-products', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const productIds = $btn.data('product-skus');
        console.log(productIds);
        const items = productIds.map(function (productId) {
            return { productId: productId };
        });
        console.log("window.cpAddItemsToCart", window.cpAddItemsToCart);
        if (window.cpAddItemsToCart && items) {
            window.cpAddItemsToCart(items);
        }
    });

    // Dynamic Loading for Post TOC
    const postTocElement = document.getElementById('post-toc');
    if (postTocElement) {
        import('./post-toc.js')
            .then(({ default: initPostTOC }) => {
                initPostTOC();
                console.log('Post TOC Loaded');
            })
            .catch(err => {
                console.error('Failed to load Post TOC:', err);
            });
    }

    // Mega Menu Hover Interaction
    const $megaMenu = $('#mega-menu-products');

    // Find the Products link by text content
    const $productsLink = $('#masthead nav .menu-item a').filter(function () {
        return $(this).text().trim() === 'Products';
    });

    if ($megaMenu.length && $productsLink.length) {
        let hoverTimeout;

        function showMenu() {
            clearTimeout(hoverTimeout);
            if ($megaMenu.hasClass('hidden')) {
                $megaMenu.removeClass('hidden');
                // Trigger reflow to allow transition from display: none
                $megaMenu[0].offsetHeight;
            }
            $megaMenu.removeClass('invisible opacity-0').addClass('visible opacity-100');
            $megaMenu.attr('aria-hidden', 'false');
        }

        function hideMenu() {
            hoverTimeout = setTimeout(function () {
                $megaMenu.removeClass('visible opacity-100').addClass('invisible opacity-0');
                
                // Add hidden after transition
                setTimeout(() => {
                    if ($megaMenu.hasClass('invisible')) {
                        $megaMenu.addClass('hidden');
                    }
                }, 300);

                $megaMenu.attr('aria-hidden', 'true');
                $productsLink.removeClass('text-primary');
            }, 300); // 300ms delay to allow moving mouse to the menu
        }

        // Events on the Products Link
        $productsLink.on('mouseenter', showMenu);
        $productsLink.on('mouseleave', hideMenu);

        // Events on the Mega Menu itself (keep open when hovering menu)
        $megaMenu.on('mouseenter', showMenu);
        $megaMenu.on('mouseleave', hideMenu);
    }
});
